
import React, { useContext, useMemo, useState } from "react";
import ReactPaginate from "react-paginate";


import GlobeShowingEuropeAfrica from "../../assets/icons/GlobeShowingEuropeAfrica";
import DocumentFolder from "../../assets/icons/DocumentFolder";
import PottedPlant from "../../assets/icons/PottedPlant";
import Tradingview from "../../assets/icons/TradingView";

import { GlobalStateContext } from "../../context/GlobalStateContext";
import styles from "./CompaniesListStyle.module.css";
import "./CompanyListStyle.css";

const COMPANIES_PER_PAGE = 10;

function CompanyRow({ company }) {
  const isNegative = company.stockPriceDelta < 0;
  const [index, symbol] = company.symbol.split(":");

  return (
    <div key={company.companyID} className={styles.tickerItem}>
      <div className={styles.topRow}>
        <div className={styles.left}>
          <span className={styles.name}>{company.companyName}</span>

          {/* LINKS ROW */}
          <div className={styles.links}>
            <a
              href={company.IRwebsiteLink}
              target="_blank"
              rel="noreferrer"
              className={styles.link}
              aria-label="Company website"
            >
              <GlobeShowingEuropeAfrica/>
            </a>
            <a
              href={company.annualReportLink}
              target="_blank"
              rel="noreferrer"
              className={styles.link}
              aria-label="Annual report 2024"
            >
              <DocumentFolder />
            </a>
            <a
              href="#"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
              aria-label="Our Expert Sustainability Analysis"
            >
              <PottedPlant />
            </a>
            <a
              href={`https://www.tradingview.com/symbols/${company.symbol}`}
              target="_blank"
              rel="noreferrer"
              className={styles.link}
              aria-label="TradingView Profile"
            >
              <Tradingview/>
            </a>
          </div>
        </div>

        <div className={styles.right}>
          <span className={styles.index}>{index}:{symbol}</span>
          <span className={styles.price}>{company.stockPrice}</span>
          <span
            className={`${styles.delta} ${
              isNegative ? styles.negative : styles.positive
            }`}
          >
            {isNegative ? "▼" : "▲"} {company.stockPriceDelta}%
          </span>
        </div>
      </div>
    </div>
  );
}
function CompaniesList({}) {
  const { filteredCompanies } = useContext(GlobalStateContext);

  const [page, setPage] = useState(0);

  const pageCount = Math.ceil(filteredCompanies.length / COMPANIES_PER_PAGE);

  const currentItems = useMemo(() => {
    const start = page * COMPANIES_PER_PAGE;
    return filteredCompanies.slice(start, start + COMPANIES_PER_PAGE);
  }, [filteredCompanies, page, COMPANIES_PER_PAGE]);

  return (
    <section className={styles.sectionThree}>
        {currentItems.map((company) => (
          <CompanyRow key={company.companyID} company={company} />
        ))}

      <ReactPaginate
        breakLabel="…"
        nextLabel="→"
        previousLabel="←"
        onPageChange={(e) => setPage(e.selected)}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        forcePage={page}
        containerClassName={styles.paginate}
        pageClassName={styles.paginate__page}
        pageLinkClassName={styles.paginate__link}
        activeClassName={styles["paginate__page--active"]}
        previousClassName={styles.paginate__nav}
        nextClassName={styles.paginate__nav}
        disabledClassName={styles["paginate__nav--disabled"]}
      />
    </section>
  );
}

export default CompaniesList;
